module.exports = __webpack_public_path__ + "img/4-4-marquee.e15c2b29.jpg";